import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Screens
 */
import LayoutPage from '../../Screens/Layout/LayoutPage';
import HomePage from '../../Screens/Home/HomePage';
import AssetScreen from '../../Screens/Asset/AssetScreen';
import AssetDetailScreen from '../../Screens/Asset/AssetDetailScreen';
import SettingScreen from '../../Screens/Setting/SettingScreen';
import MenuScreen from '../../Screens/Menu/MenuScreen';
import CategoryScreen from '../../Screens/Category/CategoryScreen';
import TypeScreen from '../../Screens/Type/TypeScreen';
import FilterScreen from '../../Screens/Filter/FilterScreen';
import LogScreen from '../../Screens/Log/LogScreen';
import UserScreen from '../../Screens/User/UserScreen';
import UserDetailScreen from '../../Screens/User/UserDetailScreen';
import RoleScreen from '../../Screens/Role/RoleScreen';
import NotFound from "../../Screens/Error/NotFound";
import AssetDetailPage from '../../Screens/Assets/AssetDetailPage';
import AssetSearchResultPage from '../../Screens/Assets/AssetSearchResultPage';
import AssetFavoritePage from '../../Screens/Assets/AssetFavoritePage';
import LimitScreen from '../../Screens/ObsLimit/LimitScreen';
import ThumbnailScreen from '../../Screens/Thumbnail/ThumbnailScreen';
import MetaScreen from '../../Screens/Meta/MetaScreen';
import AssetBatchUpload from '../../Screens/Asset/AssetBatchScreen';

const routeList = [
  '/home',
  '/asset',
  '/asset/add/new',
  '/asset/edit/:id',
  '/asset/search',
  '/asset/detail/:id',
  '/setting/thumbnail',
  '/setting/meta',
  '/setting/limit',
  '/setting/menu',
  '/setting/type',
  '/setting/filter',
  '/setting/log',
  '/setting/user',
  '/setting/user/:pageState/:id',
  '/setting/role',
  '/favorite',
  '/setting',
  '/menu',
  '/category',
  '/type',
  '/filter',
  '/log',
  '/user',
  '/role',
  '/dashboard',
  '/asset-batch'
];

const tryRequire = (path) => {
  let match = 0;

  for (let key in routeList) {
    if (matchPath(routeList[key], path)) {
      match++;
    }
  }

  if (match > 0) {
    return true;
  } else {
    return false;
  }

};

const ToHome = () => {
  const refreshPath = useSelector(({ auth: { refreshPath } }) => refreshPath);
  const path = refreshPath.replace('login', 'dashboard').split('/').slice(0, 6).join('/');

  if (tryRequire(path)) {
    return <Navigate to={path} replace={true} />;
  } else {
    return <Navigate to='/not-found' replace={true} />;
  }
};

export const PagesNavigation = ({ }) => {
  const { userInfo } = useSelector(state => state.auth);
  if (userInfo) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LayoutPage />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/asset/detail/:id" element={<AssetDetailPage />} />
            <Route path="/asset-batch" element={<AssetBatchUpload />} />
            <Route path="/asset/search" element={<AssetSearchResultPage />} />
            <Route path="/dashboard" element={<HomePage />} />
            <Route path="/asset" element={<AssetScreen />} />
            <Route path="/favorite" element={<AssetFavoritePage />} />
            <Route path="/asset/:pageState/:id" element={<AssetDetailScreen />} />
            <Route path="/setting" element={<SettingScreen />} >
              <Route path="/setting/" element={<LogScreen />} />
              <Route path="/setting/menu" element={<MenuScreen />} />
              <Route path="/setting/category" element={<CategoryScreen />} />
              <Route path="/setting/type" element={<TypeScreen />} />
              <Route path="/setting/filter" element={<FilterScreen />} />
              <Route path="/setting/log" element={<LogScreen />} />
              {/* <Route path="/setting/thumbnail" element={<ThumbnailScreen />} /> */}
              <Route path="/setting/meta" element={<MetaScreen />} />
              <Route path="/setting/limit" element={<LimitScreen />} />
              <Route path="/setting/user" element={<UserScreen />} />
              <Route path="/setting/user/:pageState/:id" element={<UserDetailScreen />} />
              <Route path="/setting/role" element={<RoleScreen />} />
            </Route >
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/*" element={<ToHome />} />
          </Route >
        </Routes >
      </BrowserRouter >
    )
  } else {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LayoutPage />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/dashboard" element={<HomePage />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/*" element={<ToHome />} />
          </Route >
        </Routes >
      </BrowserRouter >
    )
  }
}

export default PagesNavigation;